<template>
  <canvas :id="id" />
</template>

<script lang="ts" setup>
import QRCode from 'qrcode';
//
const props = defineProps({
  url: { type: String, required: true },
  canvasid: { type: String, required: false },
});

const id = props.canvasid
  ? 'qr_code_canvas_' + props.canvasid
  : 'qr_code_canvas';

watch(
  () => props.url,
  (value) => {
    // Updating url
    const url = value;
    const id = props.canvasid
      ? 'qr_code_canvas_' + props.canvasid
      : 'qr_code_canvas';
    QRCode.toCanvas(document.getElementById(id), url, function (error) {
      if (error) console.error(error);
    });
  }
);

onNuxtReady(() => {
  const url = props.url;
  const id = props.canvasid
    ? 'qr_code_canvas_' + props.canvasid
    : 'qr_code_canvas';
  QRCode.toCanvas(document.getElementById(id), url, function (error) {
    if (error) console.error(error);
  });
});
</script>
